import React, { FC, useContext } from 'react'
import { WebcamLandingAdvertising } from '../../../../common/advertising/WebcamLandingAdvertising'
import { MessagesContext } from '../../../../common/intl/MessagesContext'
import { LandingFeatures } from '../../../../components/LandingFeatures'

export const WebcamLanding: FC = () => {
  const { webcam } = useContext(MessagesContext)

  return (
    <div className="container">
      <LandingFeatures title={webcam?.features?.title} items={webcam?.features?.items} />

      <WebcamLandingAdvertising />

      <LandingFeatures title={webcam?.how?.title} items={webcam?.how?.items} />

      <LandingFeatures title={webcam?.why?.title} items={webcam?.why?.items} />
    </div>
  )
}
